import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { EnvironmentConfigurationService } from './env.config.service';
import { switchMap, tap } from 'rxjs/operators';
import { AuthService } from './auth';
import { InitTranslationService } from './init-translation.service';
import { NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { SCIPConfiguration } from '@scip/api';
import { FeatureService } from './feature.service';

@Injectable({
  providedIn: 'root'
})
export class InitService {
  constructor(
    private translationInitService: InitTranslationService,
    private authService: AuthService,
    private envConfigService: EnvironmentConfigurationService,
    private logger: NGXLogger,
    private apiConfig: SCIPConfiguration,
    private featureService: FeatureService
  ) {}

  initApplication(): Observable<any> {
    this.setupBackendUrl();
    this.setLoggingLevel(this.envConfigService.environment.loggingLevel);
    (window as any).scipui = { setLoggingLevel: this.setLoggingLevel.bind(this) };

    // First lets authenticate and afterwards setup the language as it depends on the language of the user
    return this.setupAuthentication().pipe(
      tap(() => this.featureService.initializeFeatureConfig()),
      switchMap(() => this.initTranslation())
    );
  }

  // It is possible to connect the ui to different deployed backends, so lets read
  // the configuration (environment-variable) and use that value
  private setupBackendUrl() {
    this.apiConfig.basePath = this.envConfigService.environment.apiUrl;
  }

  private setupAuthentication(): Observable<boolean> {
    return from(this.authService.setupOauthService(this.envConfigService.environment));
  }

  private initTranslation(): Observable<any> {
    return this.translationInitService.initTranslationService();
  }

  private setLoggingLevel(newLevel: string) {
    const config = this.logger.getConfigSnapshot();
    let level;
    switch (newLevel) {
      case 'Error':
      case 'error':
        level = NgxLoggerLevel.ERROR;
        break;
      case 'Warn':
      case 'warn':
      case 'Warning':
      case 'warning':
        level = NgxLoggerLevel.WARN;
        break;
      case 'Log':
      case 'log':
        level = NgxLoggerLevel.LOG;
        break;
      case 'Info':
      case 'info':
        level = NgxLoggerLevel.INFO;
        break;
      default:
        level = NgxLoggerLevel.WARN;
        break;
    }
    config.level = level;
    this.logger.updateConfig(config);
  }
}
